import { Container, Section, H2 } from 'fractals'
import { Box } from '@mui/material'
import { FC } from 'react'
import { Card, HowTrainingWorksCardType } from './fractals'

type Props = {
  howTrainingWorksCards: HowTrainingWorksCardType[]
}

const HowTrainingWorks: FC<Props> = ({ howTrainingWorksCards }) => {
  return (
    <Section
      id='how-training-works'
      spacingVariant='beta'
      colorsVariant='gamma'>
      <Container>
        <Box
          display='grid'
          gap='32px'
          justifyItems='center'
          boxSizing='border-box'
          sx={{
            '@media (min-width: 1281px)': {
              gap: '56px'
            },
            '@media (max-width: 375px)': {
              gap: '24px'
            }
          }}>
          <H2 variant='howTrainingWorksTitle'>Как проходит обучение</H2>
          <Box
            display='grid'
            gap='32px'
            sx={{
              gridTemplate: 'repeat(2, 1fr) / repeat(4, 1fr)',
              '@media (max-width: 1280px)': {
                gridTemplate: 'repeat(4, 1fr) / repeat(2, 1fr)'
              },
              '@media (max-width: 768px)': {
                rowGap: '24px'
              },
              '@media (max-width: 376px)': {
                gridTemplate: 'repeat(8, 1fr) / repeat(1, 1fr)',
                rowGap: '16px'
              }
            }}>
            {howTrainingWorksCards.map(({ title, image }, index) => (
              <Card
                key={`${index + 1}`}
                number={index + 1}
                title={title}
                image={image}
              />
            ))}
          </Box>
        </Box>
      </Container>
    </Section>
  )
}

export default HowTrainingWorks
